import { render } from "./drop-arrow.vue?vue&type=template&id=6cad4caa&scoped=true"
const script = {}

import "./drop-arrow.vue?vue&type=style&index=0&id=6cad4caa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cad4caa"]])

export default __exports__